module.exports = __webpack_public_path__ + "media/images/flags/1x1/pol-22258a0745cdfd90facadd41e1572e4d.svg";